<div class="sign-in-container">
  <button mat-stroked-button
          class="sign-in-option-btn primary-btn-border google-sign-in"
          [ngClass.lt-md]="{'horizontal': true}"
          [disabled]="disabled"
          (click)="signInWithGoogle()">
    <img src="assets/google-g-logo.svg" alt="Google logo" class="social-logo"/>
    <ng-container i18n="Social Sign In|Sign in with Google@@social-sign-in-google">Sign In with Google&nbsp;&nbsp;&nbsp;&nbsp;</ng-container>
  </button>

  <button mat-stroked-button
          class="sign-in-option-btn facebook-sign-in"
          [disabled]="disabled"
          (click)="signInWithFacebook()">
    <img src="assets/facebook-logo.svg" alt="Facebook logo" class="social-logo"/>
    <ng-container i18n="Social Sign In|Sign in with Facebook@@social-sign-in-facebook">Sign In with Facebook</ng-container>
  </button>
</div>
